module.exports = __webpack_public_path__ + "static/media/import_learningScore1.23a4fade.xlsx";